export const GROOVE_CHAT_TEAM_IDS = {
  HOME_SERVICES: '919ad840-5e3c-4e8d-9fbe-8d3faf789dac',
  mortgages: '5d602b42-f7df-4287-b377-fc31806987ea',
  protection: 'db675d1f-26c5-42c8-87ea-1f2a9f4d8700',
  home_insurance: '33b72d5a-be8d-4afc-ab9c-a18b37be60b5'
};

export const GROOVE_CHAT_TEAM_ID_MAPPINGS = {
  '/compare-gas-electricity-prices/': GROOVE_CHAT_TEAM_IDS.HOME_SERVICES,
  '/compare-mortgages/': GROOVE_CHAT_TEAM_IDS.mortgages,
  '/compare-mortgage-protection-insurance/': GROOVE_CHAT_TEAM_IDS.protection,
  '/compare-life-insurance/': GROOVE_CHAT_TEAM_IDS.protection,
  '/compare-serious-illness-cover/ ': GROOVE_CHAT_TEAM_IDS.protection,
  '/compare-home-insurance/': GROOVE_CHAT_TEAM_IDS.home_insurance,
  '/': GROOVE_CHAT_TEAM_IDS.HOME_SERVICES,
  '/compare-car-insurance/': GROOVE_CHAT_TEAM_IDS.home_insurance
};
